import script from "./Occupy.vue?vue&type=script&lang=ts&setup=true"
export * from "./Occupy.vue?vue&type=script&lang=ts&setup=true"

import "./Occupy.vue?vue&type=style&index=0&id=42989518&lang=scss"

const __exports__ = script;

export default __exports__